import {
    AGENIUM_OCUPATION_LIST,
    APPROVED_AS_APPLIED,
    APPROVED_BETTER_THAN_APPLIED,
    APPROVED_WORSE_THAN_APPLIED,
    STATE_OPTIONS,
} from '../../../Agent/constants';
import {Categories} from './types';

export const fieldCategory = {
    agentName: Categories.AGENT_INFORMATION,
    bdsName: Categories.AGENT_INFORMATION,
    prosperNotChosenReason: Categories.AGENT_INFORMATION,
    prosperNotChosenDetails: Categories.AGENT_INFORMATION,
    fgEverlastNotChosenReason: Categories.AGENT_INFORMATION,
    agentProducts: Categories.AGENT_INFORMATION,
    firstName: Categories.BASIC_INFORMATION,
    lastName: Categories.BASIC_INFORMATION,
    middleName: Categories.BASIC_INFORMATION,
    suffix: Categories.BASIC_INFORMATION,
    phoneNumber: Categories.BASIC_INFORMATION,
    bestTimeToCall: Categories.BASIC_INFORMATION,
    emailAddress: Categories.BASIC_INFORMATION,
    bmonth: Categories.BASIC_INFORMATION,
    bday: Categories.BASIC_INFORMATION,
    byear: Categories.BASIC_INFORMATION,
    age: Categories.BASIC_INFORMATION,
    gender: Categories.BASIC_INFORMATION,
    maritalStatus: Categories.BASIC_INFORMATION,
    address: Categories.BASIC_INFORMATION,
    addressCity: Categories.BASIC_INFORMATION,
    state: Categories.BASIC_INFORMATION,
    addressZipCode: Categories.BASIC_INFORMATION,
    height: Categories.BASIC_INFORMATION,
    weight: Categories.BASIC_INFORMATION,
    weightChanged: Categories.BASIC_INFORMATION,
    sameOwner: Categories.BASIC_INFORMATION,
    policyOwnerName: Categories.BASIC_INFORMATION,
    ownerSocialSecurityNumber: Categories.BASIC_INFORMATION,
    ownerBMonth: Categories.BASIC_INFORMATION,
    ownerBday: Categories.BASIC_INFORMATION,
    ownerByear: Categories.BASIC_INFORMATION,
    ownerIssueState: Categories.BASIC_INFORMATION,
    ownerNumber: Categories.BASIC_INFORMATION,
    ownerExpiration: Categories.BASIC_INFORMATION,
    amountOfCoverageMomHas: Categories.BASIC_INFORMATION,
    amountOfCoverageDadHas: Categories.BASIC_INFORMATION,
    ownerCitizenshipCountry: Categories.BASIC_INFORMATION,
    relationshipToInsured: Categories.BASIC_INFORMATION,
    policyOwnerPhone: Categories.BASIC_INFORMATION,
    policyOwnerEmail: Categories.BASIC_INFORMATION,
    policyOwnerStreetAddress: Categories.BASIC_INFORMATION,
    policyOwnerState: Categories.BASIC_INFORMATION,
    policyOwnerCity: Categories.BASIC_INFORMATION,
    policyOwnerZipcode: Categories.BASIC_INFORMATION,
    incomeIndividual: Categories.BASIC_INFORMATION,
    incomeHouseholdText: Categories.BASIC_INFORMATION,
    currentlyEmployed: Categories.BASIC_INFORMATION,
    currentSelfEmployed: Categories.BASIC_INFORMATION,
    nameOfEmployer: Categories.BASIC_INFORMATION,
    timeEmployed: Categories.BASIC_INFORMATION,
    employmentDays: Categories.BASIC_INFORMATION,
    employerAddress: Categories.BASIC_INFORMATION,
    occupation: Categories.BASIC_INFORMATION,
    industryDuties: Categories.BASIC_INFORMATION,
    prevSelfEmployed: Categories.BASIC_INFORMATION,
    prevEmployName: Categories.BASIC_INFORMATION,
    prevEmployStart: Categories.BASIC_INFORMATION,
    prevEmployOccup: Categories.BASIC_INFORMATION,
    prevEmployIndustry: Categories.BASIC_INFORMATION,
    reasonUnemployed: Categories.BASIC_INFORMATION,
    previousJobInfo: Categories.BASIC_INFORMATION,
    previousIncome: Categories.BASIC_INFORMATION,
    retiredInfo: Categories.BASIC_INFORMATION,
    retiredIncome: Categories.BASIC_INFORMATION,
    schoolInfo: Categories.BASIC_INFORMATION,
    disabilityInfo: Categories.BASIC_INFORMATION,
    otherInfo: Categories.BASIC_INFORMATION,
    estimatedSavingsTotal: Categories.BASIC_INFORMATION,
    estimatedDebtTotal: Categories.BASIC_INFORMATION,
    birthCountry: Categories.IDENTITY,
    birthState: Categories.IDENTITY,
    birthCity: Categories.IDENTITY,
    birthAddressZipCode: Categories.IDENTITY,
    usCitizenship: Categories.IDENTITY,
    usPermResNumber: Categories.IDENTITY,
    usVisaType: Categories.IDENTITY,
    usVisaNumber: Categories.IDENTITY,
    usTinNumber: Categories.IDENTITY,
    validDriversLicense: Categories.IDENTITY,
    ndiReason: Categories.IDENTITY,
    driversLicenseState: Categories.IDENTITY,
    driversLicenseNumber: Categories.IDENTITY,
    driversLicExpiration: Categories.IDENTITY,
    stateIdState: Categories.IDENTITY,
    stateIdNumber: Categories.IDENTITY,
    stateIdExpiration: Categories.IDENTITY,
    noDriversLicenseReason: Categories.IDENTITY,
    modeOfTransport: Categories.IDENTITY,
    military: Categories.IDENTITY,
    militaryServiceBranch: Categories.IDENTITY,
    militaryServieStatus: Categories.IDENTITY,
    militaryServePeriod: Categories.IDENTITY,
    numberOfBenes: Categories.BENEFICIARIES,
    beneInfo1: Categories.BENEFICIARIES,
    benePercent1: Categories.BENEFICIARIES,
    beneRelationship1: Categories.BENEFICIARIES,
    beneRelationshipAgenium1: Categories.BENEFICIARIES,
    beneRelationshipNote1: Categories.BENEFICIARIES,
    beneMonth1: Categories.BENEFICIARIES,
    beneDay1: Categories.BENEFICIARIES,
    beneYear1: Categories.BENEFICIARIES,
    beneInfo2: Categories.BENEFICIARIES,
    benePercent2: Categories.BENEFICIARIES,
    beneRelationship2: Categories.BENEFICIARIES,
    beneRelationshipAgenium2: Categories.BENEFICIARIES,
    beneRelationshipNote2: Categories.BENEFICIARIES,
    beneMonth2: Categories.BENEFICIARIES,
    beneDay2: Categories.BENEFICIARIES,
    beneYear2: Categories.BENEFICIARIES,
    beneInfo3: Categories.BENEFICIARIES,
    benePercent3: Categories.BENEFICIARIES,
    beneRelationship3: Categories.BENEFICIARIES,
    beneRelationshipAgenium3: Categories.BENEFICIARIES,
    beneRelationshipNote3: Categories.BENEFICIARIES,
    beneMonth3: Categories.BENEFICIARIES,
    beneDay3: Categories.BENEFICIARIES,
    beneYear3: Categories.BENEFICIARIES,
    beneInfo4: Categories.BENEFICIARIES,
    benePercent4: Categories.BENEFICIARIES,
    beneRelationship4: Categories.BENEFICIARIES,
    beneRelationshipAgenium4: Categories.BENEFICIARIES,
    beneRelationshipNote4: Categories.BENEFICIARIES,
    beneMonth4: Categories.BENEFICIARIES,
    beneDay4: Categories.BENEFICIARIES,
    beneYear4: Categories.BENEFICIARIES,
    beneInfo5: Categories.BENEFICIARIES,
    benePercent5: Categories.BENEFICIARIES,
    beneRelationship5: Categories.BENEFICIARIES,
    beneRelationshipAgenium5: Categories.BENEFICIARIES,
    beneRelationshipNote5: Categories.BENEFICIARIES,
    beneMonth5: Categories.BENEFICIARIES,
    beneDay5: Categories.BENEFICIARIES,
    beneYear5: Categories.BENEFICIARIES,
    beneInfo6: Categories.BENEFICIARIES,
    benePercent6: Categories.BENEFICIARIES,
    beneRelationship6: Categories.BENEFICIARIES,
    beneRelationshipAgenium6: Categories.BENEFICIARIES,
    beneRelationshipNote6: Categories.BENEFICIARIES,
    beneMonth6: Categories.BENEFICIARIES,
    beneDay6: Categories.BENEFICIARIES,
    beneYear6: Categories.BENEFICIARIES,
    beneTotalPercent: Categories.BENEFICIARIES,
    contBene: Categories.BENEFICIARIES,
    contNumberOfBenes: Categories.BENEFICIARIES,
    calculatedContNumberOfBenes: Categories.BENEFICIARIES,
    contBeneInfo1: Categories.BENEFICIARIES,
    contBenePercent1: Categories.BENEFICIARIES,
    contBeneRelationship1: Categories.BENEFICIARIES,
    contBeneRelationshipAgenium1: Categories.BENEFICIARIES,
    contBeneRelationshipNote1: Categories.BENEFICIARIES,
    contBeneMonth1: Categories.BENEFICIARIES,
    contBday1: Categories.BENEFICIARIES,
    contBeneYear1: Categories.BENEFICIARIES,
    contBeneInfo2: Categories.BENEFICIARIES,
    contBenePercent2: Categories.BENEFICIARIES,
    contBeneRelationship2: Categories.BENEFICIARIES,
    contBeneRelationshipAgenium2: Categories.BENEFICIARIES,
    contBeneRelationshipNote2: Categories.BENEFICIARIES,
    contBeneMonth2: Categories.BENEFICIARIES,
    contBday2: Categories.BENEFICIARIES,
    contBeneYear2: Categories.BENEFICIARIES,
    contBeneInfo3: Categories.BENEFICIARIES,
    contBenePercent3: Categories.BENEFICIARIES,
    contBeneRelationship3: Categories.BENEFICIARIES,
    contBeneRelationshipAgenium3: Categories.BENEFICIARIES,
    contBeneRelationshipNote3: Categories.BENEFICIARIES,
    contBeneMonth3: Categories.BENEFICIARIES,
    contBday3: Categories.BENEFICIARIES,
    contBeneYear3: Categories.BENEFICIARIES,
    contBeneInfo4: Categories.BENEFICIARIES,
    contBenePercent4: Categories.BENEFICIARIES,
    contBeneRelationship4: Categories.BENEFICIARIES,
    contBeneRelationshipAgenium4: Categories.BENEFICIARIES,
    contBeneRelationshipNote4: Categories.BENEFICIARIES,
    contBeneMonth4: Categories.BENEFICIARIES,
    contBday4: Categories.BENEFICIARIES,
    contBeneYear4: Categories.BENEFICIARIES,
    contBeneInfo5: Categories.BENEFICIARIES,
    contBenePercent5: Categories.BENEFICIARIES,
    contBeneRelationship5: Categories.BENEFICIARIES,
    contBeneRelationshipAgenium5: Categories.BENEFICIARIES,
    contBeneRelationshipNote5: Categories.BENEFICIARIES,
    contBeneMonth5: Categories.BENEFICIARIES,
    contBday5: Categories.BENEFICIARIES,
    contBeneYear5: Categories.BENEFICIARIES,
    contBeneInfo6: Categories.BENEFICIARIES,
    contBenePercent6: Categories.BENEFICIARIES,
    contBeneRelationship6: Categories.BENEFICIARIES,
    contBeneRelationshipAgenium6: Categories.BENEFICIARIES,
    contBeneRelationshipNote6: Categories.BENEFICIARIES,
    contBeneMonth6: Categories.BENEFICIARIES,
    contBday6: Categories.BENEFICIARIES,
    contBeneYear6: Categories.BENEFICIARIES,
    contBeneTotalPercent: Categories.BENEFICIARIES,
    existingCoverage: Categories.EXISTING_POLICIES,
    existingCarrier: Categories.EXISTING_POLICIES,
    existingPolicyType: Categories.EXISTING_POLICIES,
    existingCoverageAmount: Categories.EXISTING_POLICIES,
    policyNumber: Categories.EXISTING_POLICIES,
    accidentalDeathBenefitAmount: Categories.EXISTING_POLICIES,
    howLongInforce: Categories.EXISTING_POLICIES,
    replacingExistingPolicy: Categories.EXISTING_POLICIES,
    shoppedCoverage: Categories.EXISTING_POLICIES,
    shoppedCarrier: Categories.EXISTING_POLICIES,
    shoppedPolicyType: Categories.EXISTING_POLICIES,
    shoppedCoverageAmount: Categories.EXISTING_POLICIES,
    policyEverBeenDeclined: Categories.EXISTING_POLICIES,
    additionalConditions: Categories.HEALTH,
    medicationHistory: Categories.HEALTH,
    DrugorAlcoholDependenceWithdrawal: Categories.HEALTH,
    alcoholDiagnosisDate: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholTreatment: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholTreatmentDetails: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholTreatmentDate: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholTreatmentClinic: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholDrugFree: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholBeverages: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholDrinkType: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    weeklyAlcoholicDrinks: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholDrinks: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    alcoholMember: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    DrugOrAlcoholTreatmentDetailsNotes: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    typeOfDrug: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    takingMedicineDueToDrug: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    medicineNameDueToDrug: Categories.DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL,
    DUI: Categories.HEALTH,
    DUIDate: Categories.DUI,
    duiDate: Categories.DUI,
    duiNotes: Categories.DUI,
    License: Categories.HEALTH,
    suspendedLicenseDate: Categories.LICENSE,
    suspendedLicense: Categories.LICENSE,
    licenseNotes: Categories.LICENSE,
    Movingviolations: Categories.HEALTH,
    violationNumbers: Categories.MOVING_VIOLATIONS,
    movingViolationsNotes: Categories.MOVING_VIOLATIONS,
    Criminaloffense: Categories.HEALTH,
    criminalOffenseChargeType: Categories.CRIMINAL_OFFENSE,
    criminalOffenseType: Categories.CRIMINAL_OFFENSE,
    criminalOffenseIncarcerated: Categories.CRIMINAL_OFFENSE,
    criminalOffenseIncarcerationYear: Categories.CRIMINAL_OFFENSE,
    criminalOffenseIncarcerationYearOut: Categories.CRIMINAL_OFFENSE,
    criminalOffenseProbation: Categories.CRIMINAL_OFFENSE,
    criminalOffenseDetails: Categories.CRIMINAL_OFFENSE,
    criminalOffenseDate: Categories.CRIMINAL_OFFENSE,
    criminalParole: Categories.CRIMINAL_OFFENSE,
    criminalOffenseNotes: Categories.CRIMINAL_OFFENSE,
    Bankruptcy: Categories.HEALTH,
    fgBeenAdvicedDiagnosticTestTreatmentSurgeryOrOtherProcedureWhichNotBeenPerformed: Categories.FG_HEALTH,
    fgBeenTreatedDiagnosedMenthalPhysicalDisorder: Categories.FG_HEALTH,
    fgHadEKGXRayLabTestTreatmentProcedure: Categories.FG_HEALTH,
    fgBeenHospitilezedOrHadSurgeryOrProcedure: Categories.FG_HEALTH,
    HIV: Categories.HEALTH,
    extremeSports: Categories.HEALTH,
    livingAssistance: Categories.HEALTH,
    bankruptcyYear: Categories.BANKRUPTCY,
    bankruptcyChapter: Categories.BANKRUPTCY,
    bankruptcyOpen: Categories.BANKRUPTCY,
    bankruptcyDischargeDate: Categories.BANKRUPTCY,
    bankruptcyNotes: Categories.BANKRUPTCY,
    bankruptcyMultiple: Categories.BANKRUPTCY,
    bankruptcyMultipleDetail: Categories.BANKRUPTCY,
    extremeSportsOptions: Categories.HEALTH,
    extremeSportsScubaType: Categories.HEALTH,
    extremeSportsScubaDepth: Categories.HEALTH,
    TobaccoRating: Categories.TOBACCO_AND_MARIJUANA,
    MarijuanaRating: Categories.TOBACCO_AND_MARIJUANA,
    OtherRating: Categories.TOBACCO_AND_MARIJUANA,
    tobaccoProducts: Categories.TOBACCO_AND_MARIJUANA,
    tobaccoFrequency: Categories.TOBACCO_AND_MARIJUANA,
    tobaccoLastUse: Categories.TOBACCO_AND_MARIJUANA,
    fgHeartBloodVesselsDisorder: Categories.FG_HEALTH,
    fgCirculatorySystemDisorder: Categories.FG_HEALTH,
    fgLungsOrRespiratorySystemDisorder: Categories.FG_HEALTH,
    fgImmuneSystemOrEndocrineSystemDisorder: Categories.FG_HEALTH,
    fgCancerTumorsPolypsCysts: Categories.FG_HEALTH,
    fgPsychiatricOrMentalDisorder: Categories.FG_HEALTH,
    fgLupusOrOtherConnectiveTissueDiseaseAutoimmuneDisorder: Categories.FG_HEALTH,
    fgStomachLiverIntestinesColonPancreasDiseaseDisorder: Categories.FG_HEALTH,
    fgKidneysBladderUrinarySystemProstateBreastsReproductiveSystemDiseaseDisorder: Categories.FG_HEALTH,
    fgMuscleBonesSpineJointsDiseaseDisorder: Categories.FG_HEALTH,
    fgSkinEyesEarsNoseThroatDiseaseDisorder: Categories.FG_HEALTH,
    marijuanaProducts: Categories.TOBACCO_AND_MARIJUANA,
    marijuanaFrequency: Categories.TOBACCO_AND_MARIJUANA,
    marijuanaLastUse: Categories.TOBACCO_AND_MARIJUANA,
    otherSubstance: Categories.TOBACCO_AND_MARIJUANA,
    otherProducts: Categories.TOBACCO_AND_MARIJUANA,
    otherFrequency: Categories.TOBACCO_AND_MARIJUANA,
    otherLastUse: Categories.TOBACCO_AND_MARIJUANA,
    fgAnyInsuranceDeclinedPostponedRescinded: Categories.FG_PERSONAL,
    fgTraveledResidedOutsideUSOrCanadaPast2YrOrPlanInNext2Yr: Categories.FG_PERSONAL,
    fgPleadedGuiltyBeenConvictedFelony: Categories.FG_PERSONAL,
    fgMarijuanaPast5Years: Categories.FG_PERSONAL,
    fgHeroinCocaineNarcoticsBarbituratesAmphetaminesHallucinogensControlledSubstance: Categories.FG_PERSONAL,
    fgAlcoholDrugTreatment: Categories.FG_PERSONAL,
    fgDUIDWIPast5yrs: Categories.FG_PERSONAL,
    fgMovingViolationsPast5Years: Categories.FG_PERSONAL,
    fgBankruptcyPast7Years: Categories.FG_PERSONAL,
    fgParticipateInRacingMountainClimbingScubaDivingBungeeJumpingHangGlidingSkydivingAerialSportsPast5YrsOrNext2Yrs:
        Categories.FG_PERSONAL,
    fgPilotStudentPilotCrewMemberPast5YearsOrNext2Years: Categories.FG_PERSONAL,
    fgFinancingMortgageHomeEquityLoanPremiums: Categories.FG_PERSONAL,
    fgBorrowMoneyPremium: Categories.FG_PERSONAL,
    fgLifeInsuranceAnnuitySoldAssignedToLifeSettlementViaticalSecondaryMarketProvider: Categories.FG_PERSONAL,
    fatherLiving: Categories.FAMILY_HISTORY,
    fatherAge: Categories.FAMILY_HISTORY,
    fatherPassingAge: Categories.FAMILY_HISTORY,
    fatherPassingCause: Categories.FAMILY_HISTORY,
    fatherUnknown: Categories.FAMILY_HISTORY,
    motherLiving: Categories.FAMILY_HISTORY,
    motherAge: Categories.FAMILY_HISTORY,
    motherPassingAge: Categories.FAMILY_HISTORY,
    motherPassingCause: Categories.FAMILY_HISTORY,
    motherUnknown: Categories.FAMILY_HISTORY,
    biologicalFamilyCondition: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionWhichMember: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFather: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherCancerDiagnosedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherCancerDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherCancerDiedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherCancerType: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherHeartDiseaseAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherHeartDiseaseDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherHeartDiseaseDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherDiabetesAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherDiabetesDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherDiabetesDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherStrokeAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherStrokeDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionFatherStrokeDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMother: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherCancerDiagnosedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherCancerDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherCancerDiedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherCancerType: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherHeartDiseaseAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherHeartDiseaseDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherHeartDiseaseDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherDiabetesAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherDiabetesDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherDiabetesDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherStrokeAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherStrokeDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionMotherStrokeDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrother: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherCancerDiagnosedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherCancerDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherCancerDiedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherCancerType: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherHeartDiseaseAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherHeartDiseaseDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherHeartDiseaseDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherDiabetesAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherDiabetesDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherDiabetesDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherStrokeAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherStrokeDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionBrotherStrokeDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSister: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterCancerDiagnosedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterCancerDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterCancerDiedAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterCancerType: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterHeartDiseaseAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterHeartDiseaseDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterHeartDiseaseDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterDiabetesAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterDiabetesDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterDiabetesDiedAgee: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterStrokeAge: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterStrokeDied: Categories.FAMILY_HISTORY,
    biologicalFamilyConditionSisterStrokeDiedAgee: Categories.FAMILY_HISTORY,
    primaryCarePhysician: Categories.PHYSICIAN,
    primaryCarePhysicianPhone: Categories.PHYSICIAN,
    primaryCarePhysicianAddress: Categories.PHYSICIAN,
    primaryCarePhysicianStreet: Categories.PHYSICIAN,
    primaryCarePhysicianCity: Categories.PHYSICIAN,
    primaryCarePhysicianState: Categories.PHYSICIAN,
    primaryCarePhysicianZipCode: Categories.PHYSICIAN,
    lastVisit: Categories.PHYSICIAN,
    visitReason: Categories.PHYSICIAN,
    visitOutcome: Categories.PHYSICIAN,
    specialistVisits: Categories.PHYSICIAN,
    specialistName: Categories.PHYSICIAN,
    medicalHistoryPermission: Categories.PERMISSIONS,
    submissionPermission: Categories.PERMISSIONS,
    acknowlegment: Categories.PERMISSIONS,
    socialSecurityNumber: Categories.PERMISSIONS,
    familyContactPhoneNumber: Categories.PERMISSIONS,
    familyContactEmail: Categories.PERMISSIONS,
    familyContact: Categories.PERMISSIONS,
    firstCarrierQuoted: Categories.POLICY_INFORMATION,
    firstProductType: Categories.POLICY_INFORMATION,
    firstCoverageAmount: Categories.POLICY_INFORMATION,
    firstMonthlyPremium: Categories.POLICY_INFORMATION,
    firstHealthRating: Categories.POLICY_INFORMATION,
    firstFreeResponse: Categories.POLICY_INFORMATION,
    preapprovalPivotReason: Categories.POLICY_INFORMATION,
    preapprovalPivotOtherReason: Categories.POLICY_INFORMATION,
    secondCarrierQuoted: Categories.POLICY_INFORMATION,
    secondProductType: Categories.POLICY_INFORMATION,
    secondCoverageAmount: Categories.POLICY_INFORMATION,
    secondMonthlyPremium: Categories.POLICY_INFORMATION,
    secondHealthRating: Categories.POLICY_INFORMATION,
    secondFreeResponse: Categories.POLICY_INFORMATION,
    reapplyCarrierQuoted: Categories.POLICY_INFORMATION,
    reapplyProductType: Categories.POLICY_INFORMATION,
    reapplyCoverageAmount: Categories.POLICY_INFORMATION,
    reapplyMonthlyPremium: Categories.POLICY_INFORMATION,
    reapplyHealthRating: Categories.POLICY_INFORMATION,
    nyIllustrationSigned: Categories.POLICY_INFORMATION,
    conditionalBankName: Categories.BANKING_INFORMATION,
    conditionalAccountHolder: Categories.BANKING_INFORMATION,
    conditionalRoutingNumber: Categories.BANKING_INFORMATION,
    conditionalAccountNumber: Categories.BANKING_INFORMATION,
    conditionalDraftDate: Categories.BANKING_INFORMATION,
    conditionalPaymentFreq: Categories.BANKING_INFORMATION,
    notes: Categories.NOTES,
    travelingOut: Categories.BASIC_INFORMATION,
    travelingPlace: Categories.BASIC_INFORMATION,
    travelDuration: Categories.BASIC_INFORMATION,
    travelReason: Categories.BASIC_INFORMATION,
    travelDates: Categories.BASIC_INFORMATION,
    emergencyFirstName: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyLastName: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyEmail: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyPhone: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyStreetAddr: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyCity: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyState: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    emergencyZipCode: Categories.EMERGENCY_CONTACT_VUL_ONLY,
    primaryFundingSource: Categories.FINANCIALS_VUL_ONLY,
    estimatedNetWorth: Categories.FINANCIALS_VUL_ONLY,
    investedAssets: Categories.FINANCIALS_VUL_ONLY,
    investmentObjective: Categories.FINANCIALS_VUL_ONLY,
    investmentTimeFrame: Categories.FINANCIALS_VUL_ONLY,
    investmentRisk: Categories.FINANCIALS_VUL_ONLY,
    investmentGeneralKnowledge: Categories.FINANCIALS_VUL_ONLY,
    effectiveTaxRate: Categories.FINANCIALS_VUL_ONLY,
    annualExpenses: Categories.FINANCIALS_VUL_ONLY,
    emergencyFundAmount: Categories.FINANCIALS_VUL_ONLY,
    equitableCDS: Categories.FINANCIALS_VUL_ONLY,
    equitableStocks: Categories.FINANCIALS_VUL_ONLY,
    equitableBonds: Categories.FINANCIALS_VUL_ONLY,
    equitableAnnuities: Categories.FINANCIALS_VUL_ONLY,
    equitableMutualFunds: Categories.FINANCIALS_VUL_ONLY,
    equitableOtherProperties: Categories.FINANCIALS_VUL_ONLY,
    equitableRetirementAccounts: Categories.FINANCIALS_VUL_ONLY,
    equitableOtherValue: Categories.FINANCIALS_VUL_ONLY,
    totalAssets: Categories.FINANCIALS_VUL_ONLY,
    equitableInvenstmentExpWithCDs: Categories.FINANCIALS_VUL_ONLY,
    equitableInvenstmentExpWithStocks: Categories.FINANCIALS_VUL_ONLY,
    equitableInvenstmentExpWithBonds: Categories.FINANCIALS_VUL_ONLY,
    equitableInvenstmentExpWithAnnuities: Categories.FINANCIALS_VUL_ONLY,
    equitableInvenstmentExpWithMutualFunds: Categories.FINANCIALS_VUL_ONLY,
    equitableInvestmentPurposeRecommendation: Categories.FINANCIALS_VUL_ONLY,
    equitableInvestmentRisk: Categories.FINANCIALS_VUL_ONLY,
    equitableEffectiveTaxRate: Categories.FINANCIALS_VUL_ONLY,
    equitableConcerns: Categories.FINANCIALS_VUL_ONLY,
    isPrincipalProtectionOrIncomeGuarantees: Categories.FINANCIALS_VUL_ONLY,
    interestedInAdditionalPolicy: Categories.UPSELL_OPPORTUNITIES,
    upsellMaritalStatus: Categories.UPSELL_OPPORTUNITIES,
    kidsNumber: Categories.UPSELL_OPPORTUNITIES,
};

export const fieldOptions = {
    maritalStatus: {options: ['Single', 'Married', 'Divorced', 'Separated', 'Widowed']},
    ownerIssueState: {
        options: ['State ID', ...STATE_OPTIONS],
    },
    policyOwnerState: {
        options: ['State ID', ...STATE_OPTIONS],
    },
    currentlyEmployed: {
        options: ['Employed', 'Homemaker - Spouse Employed', 'Unemployed', 'Retired', 'Student', 'Disability', 'Other'],
    },
    occupation: {
        options: AGENIUM_OCUPATION_LIST,
    },
    birthState: {
        options: ['Not born in the U.S.', ...STATE_OPTIONS],
    },
    usCitizenship: {
        options: ['Yes', 'Permanent Resident', 'U.S. Visa Holder', 'No U.S. Visa - TIN only'],
    },
    validDriversLicense: {
        options: ['Yes', 'State ID', 'No ID - Applicant is a Minor', 'No ID'],
    },
    driversLicenseState: {
        options: STATE_OPTIONS,
    },
    stateIdState: {
        options: STATE_OPTIONS,
    },
    noDriversLicenseReason: {
        options: ['I have never had a license', 'My license has lapsed', 'My license is suspended'],
    },
    militaryServiceBranch: {
        options: ['Army', 'Air Force', 'Coast Guard', 'Marine Corps', 'Navy', 'Space Force'],
    },
    militaryServieStatus: {
        options: ['Active', 'Inactive', 'National Guard', 'Reservist', 'ROTC'],
    },
    numberOfBenes: {options: ['1', '2', '3', '4', '5', '6']},
    beneRelationship: {
        options: [
            'Aunt/Uncle',
            'Brother',
            'Business',
            'Business Associate',
            'Charity',
            'Child',
            'Cousin',
            'Creditor',
            'Daughter',
            'Employer',
            'Estate',
            'Father',
            'Fiance/Fiancee',
            'Former Spouse',
            'Friend',
            'Grandchild',
            'Grandparent',
            'Guardian',
            'Husband',
            'In-law',
            'Life Partner',
            'Mother',
            'Nephew',
            'Niece',
            'Parent',
            'Sibling',
            'Significant Other',
            'Sister',
            'Son',
            'Spouse',
            'Stepchild',
            'Stepparent',
            'Stepsibling',
            'Trust',
            'Wife',
            'Other',
            'Other - Person',
            'Other - Organization',
            '',
        ],
    },
    beneRelationshipAgenium: {
        options: [
            //Case_BeneDetails_RelationshipQ1
            'Spouse',
            'Daughter',
            'Son',
            'Mother',
            'Father',
            'Brother',
            'Sister',
            'Grandchildren',
            'Grandfather',
            'Grandmother',
            'Aunt',
            'Cousin',
            'Nephew',
            'Niece',
            'Uncle',
            'More', //Case_BeneDetails_RelationshipQ2
            'Parent',
            'Sibling',
            'Estate',
            'Domestic Partner',
            'Husband',
            'Trust',
            'Wife',
            'Fiance',
            'Charity',
            'Grandchild',
            'Brother-in-law',
            'Daughter-in-law',
            'Father-in-law',
            'Half Brother',
            'Half Sister',
            'Mother-in-law',
            'Sister-in-law',
            'Son-in-law',
            'Step Sibling',
            'Stepbrother',
            'Stepchild',
            'Stepdaughter',
            'Stepfather',
            'Stepmother',
            'Stepsister',
            'Stepson',
            'Child',
            'Other', //Case_BeneDetails_Other
        ],
    },
    contNumberOfBenes: {options: ['1', '2', '3', '4', '5', '6']},
    existingPolicyType: {options: ['Permanent', 'Term']},
    shoppedPolicyType: {options: ['Permanent', 'Term']},
    alcoholDrinkType: {options: ['Beer', 'Wine', 'Liquor']},
    weeklyAlcoholicDrinks: {options: ['0', '1 to 2', '3 to 5', 'more than 5']},
    alcoholMember: {
        options: ['AA (Alcoholics Anonymous)', 'NA (Narcotics Anonymous)', 'none'],
    },
    duiDate: {
        options: ['Less than five years ago', 'More than five years ago'],
    },
    criminalOffenseChargeType: {options: ['Misdemeanor', 'Felony']},
    criminalParole: {
        options: ['In the last five years', 'In the last five to ten years', 'Over ten years ago'],
    },
    bankruptcyChapter: {options: ['7', '13']},
    extremeSportsOptions: {
        options: [
            'Scuba Diving',
            'Car Racing',
            'Skydiving',
            'Motorized Racing',
            'Mountain Climbing',
            'Parachuting',
            'Aerial Sports',
            'Base Jumping',
            'Cave Exploration',
            'Hang Gliding',
            'Other',
        ],
    },
    extremeSportsScubaType: {options: ['Recreational Diver', 'Certified']},
    tobaccoProducts: {
        options: [
            'Cigarettes',
            'Cigars',
            'Pipe',
            'E-cigarettes',
            'Chewing Tobacco',
            'Nicotine Patch',
            'Nicotine Gum',
            'Snuff',
            'Others',
        ],
    },
    tobaccoFrequency: {
        options: ['Once a month or less', 'Once a week', '2-3 times a week', '4+ times a week'],
    },
    marijuanaProducts: {options: ['Smoke', 'Vape', 'Edible', 'Topical', 'Others']},
    marijuanaFrequency: {
        options: ['Once a month or less', 'Once a week', '2-3 times a week', '4+ times a week'],
    },
    otherProducts: {
        options: ['Smoke', 'Vape', 'Edible', 'Topical', 'Sniff', 'Others'],
    },
    otherFrequency: {
        options: ['Once a month or less', 'Once a week', '2-3 times a week', '4+ times a week'],
    },
    fatherLiving: {options: ['Yes', 'No', 'Unknown']},
    motherLiving: {options: ['Yes', 'No', 'Unknown']},
    biologicalFamilyCondition: {
        options: [
            'Cancer',
            "Huntington's Disease",
            "Lou Gehrig's Disease (ALS)",
            'Polycystic Kidney Disease',
            'Lynch Syndrome',
            'Heart Disease',
            'Diabetes',
            'Stroke',
            'None of the Above',
        ],
    },
    biologicalFamilyConditionWhichMember: {options: ['Father', 'Mother', 'Brother', 'Sister']},
    biologicalFamilyConditionFather: {options: ['Cancer', 'Heart Disease', 'Diabetes', 'Stroke']},
    biologicalFamilyConditionFatherCancerType: {
        options: ['Prostate', 'Testicular', 'Colon', 'Melanoma', 'Pancreatic', 'Stomach', 'Other'],
    },
    biologicalFamilyConditionMother: {options: ['Cancer', 'Heart Disease', 'Diabetes', 'Stroke']},
    biologicalFamilyConditionMotherCancerType: {
        options: [
            'Breast',
            'Cervical',
            'Endometrial',
            'Fallopian Tube',
            'Ovarian Tube',
            'Vaginal',
            'Vulvar',
            'Colon',
            'Melanoma',
            'Pancreatic',
            'Stomach',
            'Other',
        ],
    },
    biologicalFamilyConditionBrother: {options: ['Cancer', 'Heart Disease', 'Diabetes', 'Stroke']},
    biologicalFamilyConditionBrotherCancerType: {
        options: ['Prostate', 'Testicular', 'Colon', 'Melanoma', 'Pancreatic', 'Stomach', 'Other'],
    },
    biologicalFamilyConditionSister: {options: ['Cancer', 'Heart Disease', 'Diabetes', 'Stroke']},
    biologicalFamilyConditionSisterCancerType: {
        options: [
            'Breast',
            'Cervical',
            'Endometrial',
            'Fallopian Tube',
            'Ovarian Tube',
            'Vaginal',
            'Vulvar',
            'Colon',
            'Melanoma',
            'Pancreatic',
            'Stomach',
            'Other',
        ],
    },
    primaryCarePhysicianState: {
        options: STATE_OPTIONS,
    },
    firstCarrierQuoted: {
        options: [
            '',
            'F&G Everlast',
            'F&G Pathsetter',
            'F&G',
            'EMC National Life Company',
            'Ameritas',
            'National Life Group',
            'Equitable',
            'Lincoln Financial',
            'North American',
            'Pacific Life',
            'Gerber',
            'Great Western',
            'Mutual of Omaha',
            'Transamerica',
            'Allianz',
            'Assurity',
            'Principal',
            'Protective',
            'Prudential',
            'United Home Life',
            'Viva Life',
        ],
    },
    firstProductType: {
        options: [
            '',
            'IUL',
            '10-year Term',
            '15-year Term',
            '20-year Term',
            '25-year Term',
            '30-year Term',
            '35-year Term',
            '40-year Term',
            'GUL',
            'Guaranteed Issue',
            'Accidental',
            'VUL',
            'Final Expense',
            'Annuities',
        ],
    },
    firstHealthRating: {
        options: [
            '',
            'Elite Non-Tobacco',
            'Preferred Non-Tobacco',
            'Standard Plus',
            'Standard Non-Tobacco',
            'Preferred Tobacco',
            'Standard Plus Tobacco',
            'Standard Tobacco',
            'Table Rating',
        ],
    },
    secondCarrierQuoted: {
        options: [
            '',
            'F&G Everlast',
            'F&G Pathsetter',
            'F&G',
            'EMC National Life Company',
            'Ameritas',
            'National Life Group',
            'Equitable',
            'Lincoln Financial',
            'North American',
            'Pacific Life',
            'Gerber',
            'Great Western',
            'Mutual of Omaha',
            'Transamerica',
            'Allianz',
            'Assurity',
            'Principal',
            'Protective',
            'Prudential',
            'United Home Life',
            'Viva Life',
        ],
    },
    secondProductType: {
        options: [
            '',
            'IUL',
            '10-year Term',
            '15-year Term',
            '20-year Term',
            '25-year Term',
            '30-year Term',
            '35-year Term',
            '40-year Term',
            'GUL',
            'Guaranteed Issue',
            'Accidental',
            'VUL',
            'Final Expense',
            'Annuities',
        ],
    },
    secondHealthRating: {
        options: [
            '',
            'Elite Non-Tobacco',
            'Preferred Non-Tobacco',
            'Standard Plus',
            'Standard Non-Tobacco',
            'Preferred Tobacco',
            'Standard Plus Tobacco',
            'Standard Tobacco',
            'Table Rating',
        ],
    },
    reapplyCarrierQuoted: {
        options: [
            '',
            'F&G Everlast',
            'F&G Pathsetter',
            'F&G',
            'EMC National Life Company',
            'Ameritas',
            'National Life Group',
            'Lincoln Financial',
            'North American',
            'Pacific Life',
            'Gerber',
            'Great Western',
            'Mutual of Omaha',
            'Transamerica',
            'Allianz',
            'Assurity',
            'Principal',
            'Protective',
            'Prudential',
            'United Home Life',
            'Viva Life',
        ],
    },
    reapplyProductType: {
        options: [
            '',
            'IUL',
            '10-year Term',
            '15-year Term',
            '20-year Term',
            '25-year Term',
            '30-year Term',
            '35-year Term',
            '40-year Term',
            'GUL',
            'Guaranteed Issue',
            'Accidental',
            'VUL',
            'Final Expense',
            'Annuities',
        ],
    },
    reapplyHealthRating: {
        options: [
            '',
            'Elite Non-Tobacco',
            'Preferred Non-Tobacco',
            'Standard Plus',
            'Standard Non-Tobacco',
            'Preferred Tobacco',
            'Standard Plus Tobacco',
            'Standard Tobacco',
            'Table Rating',
        ],
    },
    conditionalDraftDate: {
        options: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23',
            '24',
            '25',
            '26',
            '27',
            '28',
        ],
    },
    emergencyState: {
        options: ['Not born in the U.S.', ...STATE_OPTIONS],
    },
    primaryFundingSource: {
        options: [
            'Mutual Fund (NQ)',
            'CD',
            'Retirement Plan Rollover/Transfer',
            'Current Income',
            'Money Market',
            'IRA Rollerover/Transfer',
            'Savings/Checking',
            'Line of Credit/Home Equity',
            'Client Update',
            'Change of Dealer',
            '1035 from Insurance Product',
            'Other',
        ],
    },
    investmentObjective: {
        options: [
            'Preservation of Capital',
            'Income',
            'Capital Appreciation',
            'Speculation',
            'Trading Profits',
            'Other',
        ],
    },
    investmentTimeFrame: {
        options: ['Within 2 years', '3 - 5 years', '5 - 7 years', '7 - 10 years', 'More than 10 years'],
    },
    investmentRisk: {options: ['Low risk', 'Moderate risk', 'High risk']},
    investmentGeneralKnowledge: {options: ['Limited', 'Good', 'Extensive']},
    effectiveTaxRate: {options: ['0% - 15%', '16% - 24%', '25% - 30%', 'Over 30%']},
    annualExpenses: {
        options: ['Under $50,000', '$50,001 - $100,000', '$100,001 - $500,000', 'Over $500,000'],
    },
    emergencyFundAmount: {
        options: ['Under $50,000', '$50,001 - $100,000', '$100,001 - $500,000', 'Over $500,000'],
    },
    equitableInvestmentPurposeRecommendation: {
        options: [
            'Preservation of Capital',
            'Income',
            'Speculation',
            'Capital Appreciation',
            'Trading Profits',
            'Other',
        ],
    },
    equitableInvestmentRisk: {
        options: [
            'Capitalization (large/mid/small)',
            'Concentration (under diversification)',
            'Inflation/Purchasing Power',
            'Liquidity',
            'Market Risk',
            'Volatility (includes fixed income markets)',
            'Income replacement/insuring assets against debt/final expenses',
        ],
    },
    equitableEffectiveTaxRate: {options: ['0% - 15%', '16% - 24%', '25% - 30%', 'Over 30%']},
    prosperNotChosenReason: {
        options: [
            'Eligibility: State Availability',
            'Eligibility: Over/Under Age Limits',
            'Eligibility: Below Minimum Premium',
            'Eligibility: Below Minimum Face Amount',
            'Eligibility: Underwriting Reason (Build, etc.)',
            'Eligibility: Other Reason',
            'Client Requested: Client wants Multiple Policies with same Carrier',
            'Client Requested: Higher Cap',
            'Client Requested: Higher Cash Value',
            'Client Requested: More Index Options',
            'Client Requested: Other Reason',
            'Capability: Owner/Payor Different',
            'Capability: Replacement Issue',
            'Capability: Quoting Tech Issue',
            'Capability: eApp Tech Issue',
            'Capability: Other Reason',
            'Client requested (Higher cap, option other than S&P, other)', //just for keep old data only
            'Other: Resubmit after Prosper Decline',
            'Other: Other Reason',
        ],
    },
    fgEverlastNotChosenReason: {
        options: [
            "Didn't meet minimum face amount",
            "Didn't meet age requirement",
            'Customer wanted higher CV',
            'Wanted to stay with same product as other family members',
        ],
    },
    applicationStatus: {
        options: ['Submitted', 'Approved', 'Declined', 'Delivered'],
    },
    approvedRating: {
        options: [APPROVED_AS_APPLIED, APPROVED_WORSE_THAN_APPLIED, APPROVED_BETTER_THAN_APPLIED],
    },
    declineReason: {
        options: ['Health and medication history', 'Elevated lab results', 'Consumer report', 'Build', 'Financials'],
    },
};
